// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"22ccd6e8","955":"1b7d3dce"}[chunkId] + ".chunk.css";
};